module.exports = __webpack_public_path__ + "img/furbolg_hut_small.c3e04401.png";